import { useEffect } from 'react';

import {
  PopUpWindow as BasePopUpWindow,
  type PopUpWindowProps,
} from '@xing-com/pop-up-window';

import { useSearchAndShuffleContext } from '../context';

export const PopUpWindow: React.FC<PopUpWindowProps> = ({
  isShown,
  hide,
  className,
  children,
}) => {
  const { setIsModalEnabled } = useSearchAndShuffleContext();

  const handleDisableModal = (): void => {
    setIsModalEnabled(false);
    if (hide) hide();
  };

  useEffect(() => {
    if (isShown !== undefined) {
      setIsModalEnabled(isShown);
    }
  }, [isShown, setIsModalEnabled]);

  return (
    <BasePopUpWindow
      isShown={isShown}
      onDimmerClick={handleDisableModal}
      hide={handleDisableModal}
      className={className}
    >
      {children}
    </BasePopUpWindow>
  );
};
